'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = require('./assert');

var BiLoggerManager = function () {
  function BiLoggerManager() {
    _classCallCheck(this, BiLoggerManager);

    this.reset();
  }

  _createClass(BiLoggerManager, [{
    key: 'reset',
    value: function reset() {
      this._handlers = [];
    }
  }, {
    key: 'onLoggerCreated',
    value: function onLoggerCreated(handler) {
      assert.defined(handler, 'Handler must be provided.');
      assert.func(handler, 'Handler must be a function.');

      this._handlers.push(handler);
    }
  }, {
    key: 'notifyLoggerCreated',
    value: function notifyLoggerCreated(logger) {
      this._handlers.forEach(function (handler) {
        return handler(logger);
      });
    }
  }]);

  return BiLoggerManager;
}();

module.exports = {
  manager: new BiLoggerManager(),
  BiLoggerManager: BiLoggerManager
};
//# sourceMappingURL=bi-logger-manager.js.map